import Info from '@clearkit/icons/glyphs/Info';
import { CKButton, CKIconStack } from '@clearkit/react';
import moment from 'moment';

import Logo from '~/components/ConfigurationLogo';
import { purposeForConnectorService } from '~/lib/configuration';
import history from '~/lib/history';
import paths from '~/lib/paths';

import styles from './styles.js';

const ACCOUNT_CONNECTOR_TYPES = [
  'account_connector_auth',
  'account_connector_terms',
];
const DESTIINATION_TYPES = ['destination_archived_slack_channel'];

function AccountNotification({
  classes,
  accountNotification,
  className,
  icon,
  showResolveButton,
  fixIssue,
}) {
  const {
    sourceName,
    notificationType,
    message,
    createdAt,
    segmentType,
    segmentId,
    sourceId,
  } = accountNotification;

  const isAccountConnectorNotification = ACCOUNT_CONNECTOR_TYPES.some(
    (type) => notificationType === type,
  );

  const isDestinationNotification = DESTIINATION_TYPES.some(
    (type) => notificationType === type,
  );

  let resolve = fixIssue;
  let helpText = 'Fix this issue';
  if (isDestinationNotification) {
    resolve = () =>
      history.push(
        paths.segmentDestinationEdit(segmentType, segmentId, sourceId),
      );
  } else if (notificationType === 'account_connector_terms') {
    helpText = 'Read the docs';
    resolve = () =>
      window.open(
        'https://help.clearbit.com/hc/en-us/articles/360043723133-Troubleshooting-Facebook-Ads',
      );
  }

  return (
    <div className={classnames(classes.notification, className)}>
      <div className="flex items-center mr-4">
        {(() => {
          if (icon) {
            return icon;
          }

          if (isAccountConnectorNotification || isDestinationNotification) {
            return (
              <CKIconStack
                base={<Logo type={sourceName} />}
                badge={<Info className="fill-gradient-br-yellow" />}
              />
            );
          }

          return (
            <Info className="fill-gradient-br-yellow" width={26} height={26} />
          );
        })()}
      </div>
      <div className="flex-1">
        <span className="block text-sm font-medium leading-tight text-yellow-800">
          {message ||
            `There was an error ${purposeForConnectorService(sourceName)}`}
        </span>
        {(() => {
          if (
            (!isAccountConnectorNotification && !isDestinationNotification) ||
            !sourceName
          ) {
            return null;
          }
          const action =
            notificationType === 'account_connector_auth'
              ? 'Reconnect'
              : 'Resolve';

          return (
            <span className="text-sm text-yellow-800">
              {action} to continue {purposeForConnectorService(sourceName)}
            </span>
          );
        })()}
      </div>
      <span className="text-sm text-yellow-800">
        {createdAt && moment(createdAt).calendar()}
      </span>
      <div className="ml-4">
        {showResolveButton && (
          <CKButton variantColor="yellow" variant="bold" onClick={resolve}>
            {helpText}
          </CKButton>
        )}
      </div>
    </div>
  );
}

AccountNotification.defaultProps = {
  fixIssue: () => history.push(paths.configurations()),
  showResolveButton: true,
};

AccountNotification.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  accountNotification: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountNotification);
